import React from 'react';
import {TypesContainer, TextContainer, TypesHeading,
    IndHeading, CampHeading, WhomeHeading } from '../../styles/styled/tagsStyled';

const TagTypes = () => {
    return (
        <TypesContainer marginRequired>
            <TextContainer>
                <TypesHeading>There are 3 main tag types: </TypesHeading>
                <TypesHeading subText>descriptive, individual & campaign</TypesHeading>
            </TextContainer>
            <TextContainer>
                <TypesHeading colored>Descriptive:</TypesHeading>
                <TypesHeading subText>
                    choose tags that describe your blessing, such as stories,
                    poetry, songs, or a simple appreciation for the NHS
                </TypesHeading>
            </TextContainer>
            <TextContainer>
                <WhomeHeading>For Whom:</WhomeHeading>
                <TypesHeading subText>
                    which Heroes are your Blessing for? Let everyone know so they can
                    listen to and share the blessings that mean most to them
                </TypesHeading>
            </TextContainer>
            <TextContainer>
                <IndHeading>Individual:</IndHeading>
                <TypesHeading subText>
                    are you an NHS worker or a public figure? Add an individual tag to
                    your blessing and after a quick check we’ll tag your blessing accordingly.
                    You must provide an email to use this tag, and for NHS workers your email must end with nhs.net
                </TypesHeading>
            </TextContainer>
            <TextContainer>
                <CampHeading>Campaign:</CampHeading>
                <TypesHeading subText>
                    these are campaigns and competitions that we organise to help spread the love, or to gather
                    opinions and questions. You can see active campaigns on the next tab. If you’d like to participate,
                    just choose the appropriate campaign tag! Simple... if you send a blessing for a campaign we’ll also
                    ask you to add your email address...
                </TypesHeading>
            </TextContainer>
        </TypesContainer>
    )
};

export default TagTypes;
